document.addEventListener('DOMContentLoaded', function() {
  // ヘッダーメガメニュー設定追加
  const megaMenu = document.querySelector('.mega-menu');
  const megaMenuSummary = document.querySelector('.header__menu-item');
  const megaClose = document.querySelector('.mega-menu__content_close-button');

  megaMenu.addEventListener('toggle', function() {
    if (megaMenu.open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  });
  megaClose.addEventListener('click', function() {
    megaMenu.removeAttribute('open');
    megaMenuSummary.setAttribute('aria-expanded', 'false');
  });

  // ドロワーメニューSearchボタン
  const searchButton = document.querySelector('#HeaderDrawer-Search');
  const searchModal = document.querySelector('#drawer-search-modal');
  const searchClose = document.querySelector('.modal__close-button.link');
  const searchModalContent = document.querySelector('#drawer-search-modal .modal-overlay');

  searchButton.addEventListener('click', function() {
    searchModal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  });
  searchClose.addEventListener('click', function() {
    searchModal.classList.remove('is-active');
    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden-mobile');
    document.body.classList.remove('overflow-hidden-tablet');
    document.body.classList.remove('overflow-hidden-desktop');
  });
  searchModalContent.addEventListener('click', function() {
    searchModal.classList.remove('is-active');
    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden-mobile');
    document.body.classList.remove('overflow-hidden-tablet');
    document.body.classList.remove('overflow-hidden-desktop');
  });
});